import { formatCurrency } from '~/utils';

export function ItemCard({
  productName,
  itemQuantity,
  unit,
  pricePerUnit,
  length,
  gradeInformation,
}: {
  productName: string;
  itemQuantity: number;
  unit: string;
  pricePerUnit: number;
  length: string;
  gradeInformation: string;
}) {
  return (
    <div className="divide-y divide-gray-100 p-6 flex gap-4">
      <div className="w-20 h-20 bg-gradient-to-br from-amber-50 to-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
        <div className="text-2xl">🌲</div>
      </div>
      <div className="flex-1 min-w-0 flex flex-col gap-1">
        <h4 className="text-sm text-neutral-900 font-medium mb-1">
          {productName}
        </h4>
        <p className="text-xs text-gray-500">
          Grade: {gradeInformation}{' '}
          <span className="px-2 py-1 bg-neut-100 rounded-md">{length}</span>
        </p>
        <p className="text-xs text-gray-500">
          {itemQuantity} {unit} × {formatCurrency(pricePerUnit)}/{unit}
        </p>
      </div>
      <div className="text-right flex-shrink-0">
        <p className="text-sm text-neutral-900 font-semibold">
          {formatCurrency(pricePerUnit * itemQuantity)}
        </p>
      </div>
    </div>
  );
}
